module.exports = __webpack_public_path__ + "shop_line.svg?4b0004792c400a66ca896108ed4c026b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shop_line.svg
// module id = 32
// module chunks = 0